@if (filteredEntries$ | async; as orderEntries) {
  <h3 class="title">Состав заказа</h3>

  @if (showDeliverySwitch$ | async) {
    <sd-order-delivery-filter></sd-order-delivery-filter>
  }

  @if (orderEntries?.length) {
    <div class="entries">
      <div class="col-12">
        @for (item of orderEntries; track item) {
          @if (item.deliveryType.pickup && orderEntries?.length > 1) {
            <div class="address-group" [id]="item.deliveryType.pickup.address">
              {{ item.deliveryType.pickup.address }}
            </div>

            @if (item.deliveryType.pickup.scheme) {
              <div class="scheme">
                <button
                  type="button"
                  (click)="openScheme(item.deliveryType.pickup.scheme, item.entry)"
                  class="scheme-btn"
                >
                  Схема проезда по складу
                </button>
              </div>
            }
          } @else if (item.deliveryType.delivery && orderEntries?.length > 1) {
            <div class="address-group" [id]="item.deliveryType.delivery.address">
              {{ item.deliveryType.delivery.address }}
            </div>
          }
          <sd-order-item-list [items]="item.entry" [promotionLocation]="promotionLocation"></sd-order-item-list>
        }
      </div>
    </div>
  }
}
